import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import MobileSideBar from './MobileSideBar';
import menu_arrow_icon from '../../../../assets/icons/menu_arrow_icon.svg';
import log_back_icon from '../../../../assets/images/log_back_icon.svg';

interface SubMenuProps {
  isOpen: boolean;
}

const Sidebar = styled.div`
  position: sticky;
  top: 4rem;
  overflow-y: scroll;
  padding-right: 1rem;
  height: calc(100vh - 7rem);
  width: 200px;
  border: none;
  font-size: 14px;
  font-weight: 300;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
  }
  ::-webkit-scrollbar-thumb {
    background-color: #e5e1e1;
    border-radius: 10px;
  }
  @media (max-width: 768px) {
    width: 100vw;
    padding-right: 0;
    height: fit-content;
  }
`;

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
`;

const AppIcon = styled.img`
  width: 60px;
  margin-bottom: 2rem;
`;

const MenuItem = styled.div`
  padding: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    cursor: pointer;
  }
`;

const MenuItemText = styled.div``;

const MenuItemArrow = styled.div<SubMenuProps>`
  background-image: url(${menu_arrow_icon});
  background-size: contain;
  background-repeat: no-repeat;
  width: 10px;
  height: 10px;
  margin-top: 3px;
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition: all 0.2s ease-in-out;
`;

const SubMenu = styled.div<SubMenuProps>`
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  ${MenuItem} {
    width: 170px;
    margin-left: 1rem;
    padding-left: 1rem;
    border-left: 2px solid #e1dfd9;
    &:hover {
      border-left: 2px solid #d5b343;
    }
  }
`;

interface SideBarProps {
  scrollToElement: any;
}

const SideBar = ({ scrollToElement }: SideBarProps) => {
  const [activePage, setActivePage] = useState<any>(null);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const handleMenuClick = (event: any, element: string) => {
    scrollToElement(element);
    setIsSubMenuOpen(false);
    if (!event.target.classList.value.includes('active')) {
      event.target.classList.toggle('active');
      if (activePage) activePage.classList.remove('active');
      setActivePage(event.target);
    }
  };

  const handleOpenSubmenu = () => {
    setIsSubMenuOpen((prevState) => !prevState);
  };

  const handleSubMenuClick = (event: any, element: string) => {
    scrollToElement(element);
    if (!event.target.classList.value.includes('active')) {
      event.target.classList.toggle('active');
      if (activePage) activePage.classList.remove('active');
      setActivePage(event.target);
    }
  };

  return (
    <Sidebar>
      {isMobile ? (
        <MobileSideBar handleMenuClick={handleMenuClick} />
      ) : (
        <Menu>
          <AppIcon src={log_back_icon} />
          <MenuItem
            className="menu-item"
            onClick={(event) => {
              handleMenuClick(event, 'installation');
            }}
          >
            Installation
          </MenuItem>
          <MenuItem
            className="menu-item"
            onClick={(event) => {
              handleMenuClick(event, 'get-started');
            }}
          >
            Get started
          </MenuItem>
          <MenuItem className="menu-item" onClick={handleOpenSubmenu}>
            <MenuItemText>Supported events</MenuItemText>
            <MenuItemArrow isOpen={isSubMenuOpen} />
          </MenuItem>
          <SubMenu isOpen={isSubMenuOpen}>
            <MenuItem
              className="submenu-item"
              onClick={(event) =>
                handleSubMenuClick(event, 'update-column-value')
              }
            >
              Update column value
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) => handleSubMenuClick(event, 'update-item-name')}
            >
              Update item name
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) =>
                handleSubMenuClick(event, 'update-column-name')
              }
            >
              Update column name
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) =>
                handleSubMenuClick(event, 'update-group-name')
              }
            >
              Update group name
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) =>
                handleSubMenuClick(event, 'update-group-color')
              }
            >
              Update group color
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) => handleSubMenuClick(event, 'delete-item')}
            >
              Delete item
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) => handleSubMenuClick(event, 'create-item')}
            >
              Create item
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) => handleSubMenuClick(event, 'create-column')}
            >
              Create column
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) => handleSubMenuClick(event, 'create-group')}
            >
              Create group
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) =>
                handleSubMenuClick(event, 'move-item-to-group')
              }
            >
              Move item to group
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) => handleSubMenuClick(event, 'add-subscriber')}
            >
              Add subscriber
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) =>
                handleSubMenuClick(event, 'remove-subscriber')
              }
            >
              Remove subscriber
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) => handleSubMenuClick(event, 'add-owner')}
            >
              Add owner
            </MenuItem>
            <MenuItem
              className="submenu-item"
              onClick={(event) => handleSubMenuClick(event, 'remove-owner')}
            >
              Remove owner
            </MenuItem>
          </SubMenu>
          <MenuItem
            className="menu-item"
            onClick={(event) => handleMenuClick(event, 'supported-columns')}
          >
            Supported columns
          </MenuItem>
        </Menu>
      )}
    </Sidebar>
  );
};

export default SideBar;
